// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"581d5309","607":"2f3fcd9f","702":"a23f7f09"}[chunkId] + ".chunk.css";
};